/**
 * @arg {string} src
 * @arg {Record<string, any>} [attrs]
 * @arg {Record<string, any>} [props]
 */
export function loadScript(src, attrs, props) {
  const script = document.createElement("script");
  script.src = src;
  for (const at in attrs) script.setAttribute(at, attrs[at]);
  for (const pr in props) script[pr] = props[pr];
  return document.head.appendChild(script);
}

export const noAttrs = {};
